// Phase 1 synthetic FAQ content.
export const FAQ_ITEMS = [
  {
    q: "What is GovBidIQ?",
    a: "GovBidIQ is an AI-powered government contract intelligence platform. It helps contractors make faster, more disciplined bid/no-bid decisions, score prospects, and read opportunities the way a senior capture manager would.",
  },
  {
    q: "Who should use it?",
    a: "Federal contractors who pursue more opportunities than they can humanly qualify — small businesses, set-aside firms (SDVOSB / 8(a) / WOSB / HUBZone), primes, subs, capture and proposal teams, and consultants.",
  },
  {
    q: "Is it for primes or subcontractors?",
    a: "Both. Primes use it for pipeline grooming and competitive landscape. Subs use it to profile target primes and qualify teaming opportunities.",
  },
  {
    q: "Can SDVOSBs use it?",
    a: "Yes. SDVOSB-specific signals — DoD/VA set-aside utilization, sole-source candidates, incumbent indicators — are first-class in the intelligence report.",
  },
  {
    q: "Can 8(a), WOSB, HUBZone, and other small businesses use it?",
    a: "Yes. Each set-aside has dedicated fit signals and recommended strategy. See the Use Cases page.",
  },
  {
    q: "How does it help with Go/No-Go decisions?",
    a: "A structured 100-point intelligence report with priority band (Immediate / This Week / This Month / Nurture), Top 5 reasons to pursue, Top 3 risks, and a recommended next action.",
  },
  {
    q: "How does it help with competitive intelligence?",
    a: "Incumbent indicators, recompete signals, transition risk, and probable-incumbent-advantage scoring are part of every report.",
  },
  {
    q: "Does it replace a proposal writer?",
    a: "No. It informs decisions before and during capture. Writing is still a human craft; we surface the evaluation risks your proposal needs to address.",
  },
  {
    q: "Does it replace a capture manager?",
    a: "No. It augments capture by automating opportunity qualification and pipeline triage. Your capture manager keeps the relationships and the strategy.",
  },
  {
    q: "What happens after I become a customer?",
    a: "You get a customer dashboard (Phase 3, coming soon), saved analyses, share links you can send to your team, and a customer-side AI copilot scoped to your own reports.",
  },
  {
    q: "Is my data private?",
    a: "Yes. Customer reports are accessible only via your share token today, and via your authenticated customer account in V2 Phase 3. No customer data is exposed on this public site.",
  },
  {
    q: "What can public visitors access?",
    a: "Marketing pages, the product tour, the learning center, a sample report (using synthetic data), FAQs, pricing, and the public AI assistant.",
  },
  {
    q: "What can customers access?",
    a: "Their own analyses, share links, saved reports, and (in V2) a customer-side AI copilot scoped to their data.",
  },
  {
    q: "What can admins access?",
    a: "Internal CRM, prospect intelligence, lifecycle stages, and team-management tools. Admin access is restricted to staff accounts via Google OAuth + role permissions.",
  },
];
